// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1jCL_","header":"ReportDetails_header__1j1Es","title":"ReportDetails_title__244Mg","left":"ReportDetails_left__2PrAG"};